import "./TermsOfServiceAndCookiePolicy.module.css";
import Header from "@/reusable_sections/Header";
import TermsOverview from "./sections/TermsOverview";
import PurposeOfCookies from "./sections/PurposeOfCookies";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfServiceAndCookiePolicyPage() {
  return <div>
      <Header />
      <TermsOverview />
      <PurposeOfCookies />
      <Footer />
    </div>;
}